export const invoiceRoutes = [
    {
        path: '/invoice/list',
        name: 'invoiceList',
        component: () => import('@/views/invoice/list.vue')
    },
    {
        path: '/invoice/:orderId',
        name: 'invoicePage',
        component: () => import('@/views/invoice/index.vue')
    },
    {
        path: '/address/list',
        name: 'addressList',
        component: () => import('@/views/address/index.vue')
    },
    {
        path: '/address/add',
        name: 'addressAdd',
        component: () => import('@/views/address/add.vue')
    },
    {
        path: '/invoice/detail/:invoiceId',
        name: 'addressDetail',
        component: () => import('@/views/invoice/detail.vue')
    },
    {
        path: '/invoicAdd/header',
        name: 'invoiceAdd',
        component: () => import('@/views/invoice/add.vue')
    },
    {
        path: '/invoicEdit/header',
        name: 'invoiceEdit',
        component: () => import('@/views/invoice/add.vue')
    }
];
